<!-- Component that implements a list of documents -->
<template lang="html">
  <v-container class='fluid'>
    <v-layout align-center justify-center>
      <v-flex xs10>
        <v-card>
          <basic-toolbar :title="'Bolsas Cadastradas na Universidade'"></basic-toolbar>
          <v-card-title>
            <v-spacer></v-spacer>
            <v-text-field append-icon="filter_list" label="Filtrar resultados" v-model="search"></v-text-field>
          </v-card-title>
          <v-data-table
          :headers="headers"
          :items="listaBolsas"
          :search="search"
          :no-data-text="'Nenhuma bolsa encontrada'"
          must-sort
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :items-per-page="itemsPerPage"
          :footer-props="{itemsPerPageText: 'Linhas por página', itemsPerPageOptions: opcoesPaginacao}"
          >
            <template slot="items" slot-scope="props">
              <tr>
                <td width="10%" class="text-xs-center">{{ props.item.codigo }}</td>
                <td width="40%" class="text-xs-center">{{ props.item.descricao }}</td>
                <td width="30%" class="text-xs-center">{{ props.item.unidade ? props.item.unidade.nome : '-'  }}</td>
                <td width="10%" class="text-xs-center">{{ props.item.valor }}</td>
                <td width="10%" class="text-xs-center">{{ props.item.vagasOcupadas + '/' + props.item.vagasOferecidas }}</td>
              </tr>
            </template>
            <template slot="footer.page-text" slot-scope="{ pageStart, pageStop }">
              Mostrando {{ pageStart }} a {{ pageStop }} de {{ listaBolsas.length }} bolsas
            </template>
          </v-data-table>
          <br>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn color="primary" text @click="$router.go(-1)">Cancelar</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="toCriarBolsa">Criar bolsa</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import BasicToolbar from '@/components/toolbars/basic-toolbar'
import ToolTip from '@/components/app-layouts/app-tooltip/tooltip'
import dates from '@/utils/dates'
import bolsas from '@/utils/bolsas'
import { mapActions } from 'vuex'

export default {
  data: () => ({
    listaBolsas: [],
    dates: dates,
    search: null,
    sortBy: 'dtCriacao',
    sortDesc: true,
    itemsPerPage: 10,
    opcoesPaginacao: [ 10, 25, 50, {text: 'Todas', value: -1} ],
    headers: [
      { text: 'Código', align: 'center', value: 'codigo' },
      { text: 'Descrição', align: 'center', value: 'descricao' },
      { text: 'Unidade', align: 'center', value: 'valor' },
      { text: 'Valor', align: 'center', value: 'valor' },
      { text: 'Vagas', align: 'center', value: 'vagasOferecidas' }
    ]
  }),
  props: ['items'],
  methods: {
    ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']),
    truncate (string, limit) {
      if (string.length > limit) return string.substring(0, limit) + '...'
      else return string
    },
    toCriarBolsa: function () {
      this.$router.push({name: 'CriarBolsa'})
    }
  },
  mounted () {
    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando bolsas.' })
    bolsas.getBolsas()
    .then(response => {
      this.listaBolsas = response.data.slice()
    })
    .catch(error => {
      console.log('Erro ao mandar o request' + error)
    })
    .finally(() => {
      this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando bolsas.' })
    })
  },
  components: {
    'basic-toolbar': BasicToolbar,
    'tooltip': ToolTip
  }
}
</script>

<style lang="css" slot-scoped>
</style>



// WEBPACK FOOTER //
// lista-bolsas.vue?1c92616b